/**
 * @generated SignedSource<<54450d31ebcb5deda3e116736b3af6f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoEditNewMainFooterResponseImage_todo$data = {
  readonly canWrite: boolean;
  readonly id: string;
  readonly isResponseCompleted: boolean;
  readonly response: {
    readonly images?: ReadonlyArray<{
      readonly id: string;
      readonly sizes: ReadonlyArray<{
        readonly height: number;
        readonly width: number;
      }>;
      readonly " $fragmentSpreads": FragmentRefs<"Image_image">;
    }>;
  } | null;
  readonly status: TodoStatus;
  readonly " $fragmentType": "TodoEditNewMainFooterResponseImage_todo";
};
export type TodoEditNewMainFooterResponseImage_todo$key = {
  readonly " $data"?: TodoEditNewMainFooterResponseImage_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditNewMainFooterResponseImage_todo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoEditNewMainFooterResponseImage_todo",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canWrite",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isResponseCompleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "response",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Image",
              "kind": "LinkedField",
              "name": "images",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ImageSize",
                  "kind": "LinkedField",
                  "name": "sizes",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "width",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "height",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "Image_image"
                }
              ],
              "storageKey": null
            }
          ],
          "type": "TodoResponseImage",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};
})();

(node as any).hash = "71d4afb760e68c8dcd7865e10eaa4c51";

export default node;
